import { render, staticRenderFns } from "./InvoiceTemp.vue?vue&type=template&id=3a943f54"
import script from "./InvoiceTemp.vue?vue&type=script&lang=js"
export * from "./InvoiceTemp.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTemp.vue?vue&type=style&index=0&id=3a943f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports